import React from 'react';
import {NewsListSection} from "../../components/news/NewsListSection";
import {ContactUsHiddenFormSection} from "../../components/contact-us/ContactUsHiddenFormSection";
import {Article} from "../../components/article/Article";
import {Hero} from "../../components/hero/Hero";
import {connect} from "react-redux";
import {isoDateFormat} from "../../util/DateFormat";
import {GallerySection} from "../../components/gallery/GallerySection";
import {Helmet} from "react-helmet";
import striptags from "striptags";

class NewsViewContainer extends React.Component {

  constructor(props) {
    super(props);

    this.state = {};

    this.loadNews = this.loadNews.bind(this);
  }

  componentDidMount() {
    this.loadNews(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.news)
      this.loadNews(nextProps);
  }

  loadNews(props) {
    try {
      let news = null;

      console.log(this.props.news);

      if(Array.isArray(props.news)){
        news = props.news[0];
      } else if( typeof props.news === 'object') {
        news = props.news;
      }

      if(news){
        this.setState( {
          title: news.title && news.title.rendered,
          content: news.content && news.content.rendered,
          heroImage: news.acf && news.acf.obx_hero_image && news.acf.obx_hero_image.url,
          date: isoDateFormat(news.date),
          pictures: news.acf && news.acf.obx_pictures,
          image: (() => {
            let image = null;

            try {
              image = news._embedded["wp:featuredmedia"][0].source_url;
            } catch (e) {
            }

            return image;
          })()
        });
      }

    } catch(e){}
  }


  render(){

    return (
      <div>

        <Helmet>
          <title>{ this.state.title + " | Obelux Aviation Lights" }</title>
          <meta name="description" content={ this.state.content ? striptags(this.state.content).split('.')[0] + "." : '' }></meta>
          <meta name="og:description" content={ this.state.content ? striptags(this.state.content).split('.')[0] + "." : '' }></meta>
          <meta name="og:image" content={require('../../assets/images/obelux.jpg')}></meta>
        </Helmet>

        <header>
          <Hero title={ this.state.title }
                subtitle={ this.state.date }
                image={ this.state.heroImage }
                align="center"
                className="news-hero"
                blend />
        </header>
        <Article
          content={this.state.content}/>
        <GallerySection pictures={this.state.pictures}/>
        <NewsListSection bgColor="#F4F6F7"/>
        <ContactUsHiddenFormSection/>
      </div>
    );
  }
}

export const NewsView = connect(
  state => ({
    news: ( state.resolve.data && state.resolve.data.news_story )
  })
)(NewsViewContainer);



// WEBPACK FOOTER //
// ./src/views/news/NewsView.js